import { createContext } from 'react';

/** Access for this question's UID. */
const UidContext = createContext<string>('');
export default UidContext;
